import Glide from "@glidejs/glide";

export default class Gallery {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.gallery'), el => {
			new Gallery(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;

		// in the Neos backend the element information is rendered in a appended script tag
		// since this script is executed after it's evaluation, we can safely remove it
		// to make the slider work properly
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			Array.from(document.querySelectorAll('script[data-neos-nodedata]')).forEach((script) => script.remove())
		}

		const options = {
			peek: 0,
			gap: 0,
			arrows: false,
			rewind: false,
			type: 'carousel',
			startAt: 0,
			perView: 1,
			autoplay: isNeosBackend ? false : 11000,
		};

		this.sliderElement = this.element.querySelector('.glide');
		this.slider = new Glide(this.sliderElement, options);
		this.createBullets(this.element);
		this.slider.mount();
	}

	createBullets(slider) {
		let bulletCount = slider.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length;
		let bulletWrapper = slider.querySelector('.glide__bullets');

		if (bulletCount > 1) {
			if (bulletWrapper) {
				for (let index = 0; index < bulletCount; index++) {
					const button = document.createElement('button');
					button.className = 'glide__bullet';
					button.setAttribute("data-glide-dir", '=' + index);

					button.addEventListener('click', () => {
						this.slider.go('=' + index);
					});

					bulletWrapper.appendChild(button);
				}
			}
		} else {
			if (bulletWrapper) {
				bulletWrapper.remove();
			}
		}
	}
}
